// Configuration for Clerk
export const clerkConfig = {
  publishableKey: import.meta.env.VITE_CLERK_PUBLISHABLE_KEY,
  // Any other Clerk configuration options
  appearance: {
    theme: 'default' as const,
  },

  telemetry: false,

  ...(import.meta.env.PROD &&
    import.meta.env.VITE_CLERK_CUSTOM_DOMAIN && {
      domain: import.meta.env.VITE_CLERK_CUSTOM_DOMAIN,
    }),
};
